import * as React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql, withPrefix } from "gatsby"

function Seo({ description, lang, meta, title }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description
  const defaultTitle = site.siteMetadata?.title

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      bodyAttributes={{
        class: "h-screen",
      }}
      titleTemplate={defaultTitle ? `%s | ${defaultTitle}` : null}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata?.author || ``,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ].concat(meta)}
    >
      <link
        href="https://unpkg.com/tailwindcss@^2/dist/tailwind.min.css"
        rel="stylesheet"
      ></link>
      

      <script src="https://code.jquery.com/jquery-1.12.4.min.js"></script>

      <script src={withPrefix("js/paginador.js")}></script>

      <script src={withPrefix("js/tamano_letra.js")}></script>
      <script src={withPrefix("js/fondo_contraste.js")}></script>
      <script src={withPrefix("js/mostrar_noticia.js")}></script>

      <script src={withPrefix("js/search.js")} type="text/javascript" />
      <script src={withPrefix("js/cookies.js")} type="text/javascript" />
      <script
        src={withPrefix("js/menu_responsive.js")}
        type="text/javascript"
      />

      <script
        src={withPrefix("js/footer_responsive.js")}
        type="text/javascript"
      />


      <script
        src="https://www.google.com/recaptcha/api.js"
        async
        defer
      ></script>
      <script src="https://www.google.com/recaptcha/api.js?hl=es"></script>
      <script
        src="https://kit.fontawesome.com/eb496ab1a0.js"
        crossorigin="anonymous"
      ></script>
      <script src={withPrefix("js/google_tab.js")}></script>
      <script src={withPrefix("js/boton_flotante.js")} type="text/javascript" />
    </Helmet>
  )
}

Seo.defaultProps = {
  lang: `es`,
  meta: [],
  description: ``,
}

Seo.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default Seo
